import ApiService from '@/core/services/api.service';
import { handleError } from '@/utils/common';

export const fetchStores = async () => {
  try {
    const response = await ApiService.get('stores/getStores');
    const listStore = response.data?.data || [];
    return listStore.map((element) => ({
      ...element,
      storeId: element.id,
      name: element.name,
      siteCode: element.siteCode,
    }));
  } catch (err) {
    handleError(err);
    return [];
  }
};

export const fetchCategories = async () => {
  try {
    const { data } = await ApiService.query('category');
    return data?.data?.list_caterogy || [];
  } catch (err) {
    handleError(err);
    return [];
  }
};

export const searchProducts = async (textSearch, typeSearch, typeOfProduct) => {
  try {
    const params = {
      searchProduct: textSearch ? textSearch.trim() : null,
      typeSearch,
      typeOfProduct,
    };
    const response = await ApiService.query('productSearch/search-by-type', {
      params,
    });
    return response.data?.data || [];
  } catch (err) {
    handleError(err);
    return [];
  }
};

export const searchDealSheets = async (searchQuery) => {
  try {
    const dealsheetList = (
      await ApiService.query(`v1/deal-sheets?searchText=${searchQuery}`)
    ).data?.data.dataset;

    return dealsheetList.map((item) => ({
      id: item.id,
      code: item.code,
      label: item.name,
    }));
  } catch (err) {
    handleError(err);
    return [];
  }
};

export const fetchProviders = async (params = {}) => {
  try {
    const config = Object.keys(params).length ? { params } : {};
    const response = await ApiService.get('v1/providers/all', config);
    return response.data?.data || [];
  } catch (err) {
    handleError(err);
    return [];
  }
};

export const formatImeiData = (
  {
    imeiDetails,
  }
) => {
  const sourceFromKey = {
    bill: 'Số bán thực tế',
    active: 'Kích hoạt IMEI',
    wholesale: 'Số bán sỉ',
    stockSlip: 'Nhập kho',
    import_excel: 'Import Excel',
  };

  return {
    title: `Danh sách IMEI hợp lệ để tính chiết khấu`,
    rows: imeiDetails.map((item, index) => ({
      ...item,
      index,
      sourceFromName: sourceFromKey[item.sourceFrom] || item.sourceFrom,
    })),
  };
};
